import { Resume, SingleTemplateSettings, UserDocumentTemplate } from '@rio/types'
import { useI18n } from 'builder/hooks/useI18n'

import { ColorList } from '../ColorList/ColorList'
// TODO: Enable when we have support for headings and body colors
// import { ColorPicker } from '../ColorPicker/ColorPicker'
import * as Styled from './styles'

type Props = {
  resume?: Resume
  currentTemplate?: UserDocumentTemplate
  resumeSpecificTemplateSettings?: SingleTemplateSettings
}

const TRANSLATION = 'builder.resume_editor.design_tab.template_colors'

export const Colors = (props: Props) => {
  const { i18n } = useI18n()

  const items = [
    { name: i18n.t(`${TRANSLATION}.main_color.title`), element: <ColorList {...props} /> },
    // TODO: Enable when we have support for headings and body colors
    // { name: '', element: <Styled.Separator /> },
    // {
    //   name: i18n.t(`${TRANSLATION}.headings_color.title`),
    //   element: (
    //     <ColorPicker
    //       disabled
    //       disabledTooltip={i18n.t(`${TRANSLATION}.headings_color.disabled_tooltip`)}
    //     />
    //   ),
    // },
    // {
    //   name: i18n.t(`${TRANSLATION}.body_color.title`),
    //   element: (
    //     <ColorPicker
    //       disabled
    //       disabledTooltip={i18n.t(`${TRANSLATION}.body_color.disabled_tooltip`)}
    //     />
    //   ),
    // },
  ]

  return (
    <Styled.Container>
      <Styled.ColorsList>
        {items.map(item => (
          <Styled.ColorsItem key={item.name}>
            {item.name && <Styled.ColorsItemText>{item.name}</Styled.ColorsItemText>}
            {item.element}
          </Styled.ColorsItem>
        ))}
      </Styled.ColorsList>
    </Styled.Container>
  )
}
